// extracted by mini-css-extract-plugin
export default {"produto":"Produto_produto__tDfQW","preco":"Produto_preco__F9l5e","descricao":"Produto_descricao__LNpFf"};